module.exports = __webpack_public_path__ + "img/foto2.a3b6ee48.jpg";